import { render, staticRenderFns } from "./TableDuration.vue?vue&type=template&id=e01f89c4&"
import script from "./TableDuration.vue?vue&type=script&lang=js&"
export * from "./TableDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports